module.exports = __webpack_public_path__ + "img/home.e776c047.svg";